import { render, staticRenderFns } from "./bodega-aleanna.vue?vue&type=template&id=19b3a226&scoped=true"
import script from "./bodega-aleanna.vue?vue&type=script&lang=js"
export * from "./bodega-aleanna.vue?vue&type=script&lang=js"
import style0 from "./bodega-aleanna.vue?vue&type=style&index=0&id=19b3a226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b3a226",
  null
  
)

export default component.exports